import React, { useState } from 'react'
import { createChatbotFeedback } from '../../../../api/rocketChat'

const BotFeedback = ({
  messageId,
  botResponse,
  query,
  role,
  personId,
  roomId,
  feedbacks = [],
  messageFeedback
}) => {
  const existingFeedback = feedbacks.find((f) => f.message_id === messageId)
  const messageFeedbackValue = messageFeedback
    ? messageFeedback === 'Helpful'
      ? 'helpful'
      : messageFeedback === 'Not Helpful'
      ? 'not-helpful'
      : null
    : null
  const initialFeedback = existingFeedback
    ? existingFeedback.feedback === 'Helpful'
      ? 'helpful'
      : 'not-helpful'
    : messageFeedbackValue

  const [feedback, setFeedback] = useState(initialFeedback)
  const [showThanks, setShowThanks] = useState(false)

  const getFeedbackValue = (feedbackType) => {
    const feedbackMap = {
      helpful: 'Helpful',
      'not-helpful': 'Not Helpful'
    }
    return feedbackMap[feedbackType] || null
  }

  const handleFeedback = async (type) => {
    const newFeedback = feedback === type ? null : type
    setFeedback(newFeedback)
    setShowThanks(newFeedback !== null)

    try {
      await createChatbotFeedback({
        message_id: messageId,
        query: query,
        bot_response: botResponse,
        feedback: getFeedbackValue(newFeedback),
        role: role,
        person_id: personId,
        room_id: roomId
      })
      console.log(`Feedback sent: ${newFeedback}`)
    } catch (error) {
      console.error('Failed to send feedback:', error)
    }
  }

  return (
    <>
      <div className="message-feedback">
        <span className="feedback-text">
          {role === 1 ? 'Was this helpful?' : 'Was this accurate?'}
        </span>
        <div className="feedback-buttons">
          <span
            type="button"
            className={`feedback-btn ${feedback === 'helpful' ? 'active' : ''}`}
            onClick={() => handleFeedback('helpful')}
          >
            <span role="img" aria-label="Helpful">
              👍
            </span>
          </span>
          <span
            type="button"
            className={`feedback-btn ${
              feedback === 'not-helpful' ? 'active' : ''
            }`}
            onClick={() => handleFeedback('not-helpful')}
          >
            <span role="img" aria-label="Not helpful">
              👎
            </span>
          </span>
        </div>
        {showThanks && (
          <div className="feedback-text">Thanks for your feedback!</div>
        )}
      </div>
    </>
  )
}

export default BotFeedback
